<template lang="pug">
#laudos
    el-upload.upload-demo(
        action='#',
        drag,
        :file-list='fileListVetorial',
        :limit='1',
        :on-exceed='handleExceed',
        :auto-upload='false',
        :on-change='onLoadFileVetorial',
        :on-remove='onRemoveFileVetorial',
        ref='upload'
    )
        i.el-icon-upload
        .el-upload__text.w-100(style='font-size: 16px; color: var(--grey)') {{ $t('mensagens.laudos.arrasteArquivo.1') }} <em>{{ $t('mensagens.laudos.arrasteArquivo.2') }}</em>
        .el-upload__text.w-100(style='color: var(--grey)') {{ $t('mensagens.laudos.arrasteArquivo.3') }}
    .d-flex.flex-direction.justify-content-between.py-3
        BaseButton(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
        BaseButton(
            v-if='showConfirmar',
            slot='footer',
            size='mini',
            type='primary',
            @click='confirmar'
        ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import LaudosService from '@/services/LaudosService';
import geometryConverter from '@/utils/conversorGeometrias';
import axios from 'axios';
import L from 'leaflet';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'SelecionarArquivoVetorial',

    props: {
        tipoLaudo: {
            type: Number,
            required: true
        }
    },

    emits: ['cancelar-modal', 'update:lista'],
    components: {
        BaseButton
    },

    data() {
        return {
            showUploadVetorial: false,
            showSelecaoTerritorio: false,
            showConfirmar: false,
            arquivoUpload: null,
            fileList: [],
            fileListVetorial: [],
            geometria: null,
            geometrias: []
        };
    },

    methods: {
        closeDialog() {
            this.$emit('cancelar-modal');
            this.limpar();
        },

        async confirmar() {
            if (!this.arquivoUpload) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.uploadDeArquivoObrigatorio'
                    )
                });
                return;
            }

            let arquivoUploadNome = null;
            if (this.arquivoUpload) {
                arquivoUploadNome = [];
                arquivoUploadNome.push(this.arquivoUpload.nomeArquivo);
            }

            const informacao = {
                nomeArquivos: arquivoUploadNome,
                tipoLaudoId: this.tipoLaudo,
                tipoInsumo: 'ARQUIVO_VETORIAL',
                geoJson: this.geometrias[0]
            };
            const informacaoLaudos = [];
            informacaoLaudos.push(informacao);

            try {
                await LaudosService.cadastrarLaudos({ informacaoLaudos });

                this.closeDialog();

                this.$notify.success({
                    message: this.$t(
                        'mensagens.laudos.solicitacaoRealizadaComSucesso'
                    )
                });

                this.atualizarTabela();
            } catch (e) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.erro.erroAoCadastrarLaudo'
                    )
                });
            }
        },

        async onLoadFile(file, fileList) {
            let url = process.env.VUE_APP_HTTP_PATH + '/laudo/upload-temp';
            let formData = new FormData();
            formData.append('file', file.raw);
            const { data, status } = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (status === 200) {
                const arq = { nomeArquivo: data, uid: file.uid };
                this.arquivoUpload = arq;
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.erro.naoFoiPossivelEnviarArquivo'
                    )
                });
            }
        },

        async onLoadFileVetorial(file, fileListVetorial) {
            await this.onLoadFile(file, fileListVetorial);
            this.showConfirmar = true;

            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                geometryConverter
                    .read(extension, e.target.result, file.raw)
                    .then(geometria => {
                        this.processarGeometria(geometria);

                        this.geometria = geometria;
                    })
                    .catch(rejectReason => {
                        this.arquivoUpload = null;
                        this.fileListVetorial = [];
                        this.geometria = null;
                        this.geometrias = [];
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        processarGeometria(geometria) {
            this.filtrarGeometrias(geometria);
            if (geometria !== null && geometria.getLayers().length > 0) {
                if (
                    geometria.getLayers()[0].feature.geometry.type ===
                    'GeometryCollection'
                ) {
                    _.each(geometria.getLayers()[0].getLayers(), layer =>
                        this.processarLayer(layer)
                    );
                } else {
                    _.each(geometria.getLayers(), layer =>
                        this.processarLayer(layer)
                    );
                }
            } else {
                this.arquivoUpload = null;
                this.fileListVetorial = [];
                this.geometria = null;
                this.geometrias = [];

                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.erro.arquivoNaoPossuiGeometriaValida'
                    )
                });
            }
        },

        filtrarGeometrias(layerGeometrias) {
            if (layerGeometrias === null) return;

            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }
                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },

        processarLayer(layer) {
            this.geometrias.push(layer.toGeoJSON().geometry);
        },

        async onRemoveFileVetorial(file, fileListVetorial) {
            this.showConfirmar = false;
            this.arquivoUpload = null;
            this.fileListVetorial = [];
            this.geometria = null;
            this.geometrias = [];
        },

        handleExceed() {
            this.$notify.warning(this.$t('mensagens.laudos.limiteDeUmArquivo'));
        },

        atualizarTabela() {
            this.$emit('update:lista');
        },

        limpar() {
            this.arquivoUpload = null;
            this.fileListVetorial = [];
            this.geometria = null;
            this.geometrias = [];
            this.showUploadVetorial = false;
            this.showSelecaoTerritorio = false;
            this.showConfirmar = false;
            this.arquivoUpload = null;
            this.fileList = [];
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-opcoes-laudo {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
